import * as React from "react";
import { Box, Button } from "@material-ui/core";

const CommentTestPage = () => {
    const [c, setC] = React.useState(true);

    const handleFullScreenClick2 = () => {
        setC(!c);
    };

    return (
        <div style={{ margin: 4 }}>
            <Button onClick={handleFullScreenClick2}>PE</Button>
            <div style={{ width: "100%" }}>
                <Box display="flex" p={1} bgcolor="background.paper">
                    <Box p={1} flexGrow={1} bgcolor="blue">
                        Item 1
                    </Box>
                    <Box minWidth={350} p={1} bgcolor="grey.300"></Box>
                </Box>
            </div>
        </div>
    );
};

export default CommentTestPage;
